import React from "react";
import { compose, withAppContext, withActions, withState } from "containers/HOC";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import UserList from "./UserList";
import { getMyOrg } from "./_actions";

class MyOrgUsers extends React.Component {
    componentDidMount() {
        this.props.getMyOrg();
    }

    render() {
        const { account, accountLoading, authContext, online } = this.props;

        const isAuthorised = authContext.isAdmin;
        const hasUsers = account && account.users && account.users.length > 0;

        return (
            <Panel>
                <PanelBody loading={!account && accountLoading}>
                    {!isAuthorised && (
                        <div className="Tile-body-message">
                            <p className="lead">Access denied</p>
                        </div>
                    )}
                    {isAuthorised && !hasUsers && (
                        <div className="Tile-body-message">
                            <p className="lead">No data</p>
                        </div>
                    )}
                    {isAuthorised && hasUsers && <UserList users={account.users} authContext={authContext} online={online} />}
                </PanelBody>
            </Panel>
        );
    }
}

export default compose(
    withAppContext,
    withActions({ getMyOrg }),
    withState((state) => {
        return {
            account: state.myOrg.account,
            accountLoading: state.myOrg.accountLoading,
        };
    })
)(MyOrgUsers);
